(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/replace-receiver.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/replace-receiver.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReplaceReceiver = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.replace_receiver(data);
    },
    initialize: function() {
      var self = this;
      if (svs.grassroots.collections.my_receivers) {
        this.listenTo(
          svs.grassroots.collections.my_receivers,
          'reset',
          function() {
            self.model.set(
              'currentReceivers',
              svs.grassroots.collections.my_receivers.models
            );
          }
        );
      }
      if (svs.grassroots.collections.grassroots) {
        this.listenTo(
          svs.grassroots.collections.grassroots,
          'change',
          function() {
            self.model.set(
              'currentReceivers',
              svs.grassroots.collections.grassroots.where({ myReceiver: true })
            );
          }
        );
      }
    },

    events: {
      'click .js-replace-receiver': 'replaceReceiver'
    },
    modelEvents: {
      change: 'render'
    },

    replaceReceiver: function(e) {
      var receiverToRemoveId = e.currentTarget.id.split('-')[1];
      var receiverToAdd = this.model.get('receiverToAdd').pop();
      var receiverToAddId = receiverToAdd.get('id');
      var receiverToAddName = receiverToAdd
        .get('longname');

      this.model.replaceSupport(
        receiverToAddId,
        receiverToRemoveId,
        receiverToAddName
      );
    }
  });
})(Backbone, _, svs);


 })(window);